/**
 * Neko Toys — Waiting Room (storefront UX layer) v3 · "1b Refined 叫號牌".
 *
 * Gated kuji PDPs replace the buy UI with a take-a-number board:
 *   - mobile  (≤749px): compact horizontal board fixed above the bottom nav.
 *   - desktop (≥750px): the in-column board card (#neko-waiting-room mount).
 * Both render from one state machine; CSS reshapes the same DOM per placement.
 *
 * States:
 *   idle    → black band with live player count + red 加入排隊 (登入排隊 when logged out)
 *   queued  → black band 02/04 (position/total) + 退出排隊 (standard button)
 *   active  → red band 輪到你喇！ + 去抽賞; auto-redirect (once) to ?view=turn
 *   opening → paid, opening tickets — status board, no buttons (auto-release)
 *   blockedElsewhere → live count + switch button (退出排緊嘅隊，排呢度);
 *                      heldOpening=true → status only, switch NOT offered
 *
 * Queue exit rule (2026-07-12): ONLY the 退出排隊 button or the turn countdown
 * expiring removes a member — refresh, app-switch and long background stays
 * all keep the spot. Live kuji: dispatches `neko:queue-changed` on movement.
 *
 * This is UX ONLY — the Cart/Checkout Validation Function is the real gate,
 * so this script FAILS OPEN on backend errors.
 */
(function () {
  "use strict";

  var POLL_MS = 4000;
  var GATED_CLASS = "neko-wr-gated";

  var root = document.getElementById("neko-waiting-room");
  if (!root) return;

  var gated = root.getAttribute("data-gated") === "true";
  var loggedIn = root.getAttribute("data-logged-in") === "true";
  var proxyBase = root.getAttribute("data-proxy-base") || "/apps/queue";
  var loginUrl = root.getAttribute("data-login-url") || "/account/login";
  var variantId = root.getAttribute("data-variant-id");
  var productTitle = root.getAttribute("data-product-title") || "";
  var variantTitle = root.getAttribute("data-variant-title") || "";
  var productUrl = (root.getAttribute("data-product-url") || window.location.pathname).split("?")[0];

  var pollTimer = null;
  var currentState = null; // last state string, for the unload beacon
  var lastSig = null; // last state signature, to detect queue movement
  var pollCount = 0; // for the every-4th-poll kuji catch-all while queued

  // ---- SVG line icons (design system: stroke icons, no emoji) ----
  var ICON_PEOPLE =
    '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fdd900" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>';
  var ICON_WARN =
    '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#121212" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>';
  var ICON_CHECK =
    '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#d81f26" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>';
  var ICON_ARROW =
    '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>';

  function pad2(n) {
    n = Number(n) || 0;
    return n < 10 ? "0" + n : String(n);
  }

  // Tell listeners (neko-kuji-status.js) the queue moved → refetch kuji status.
  function announceQueueChange() {
    try {
      document.dispatchEvent(new CustomEvent("neko:queue-changed"));
    } catch (e) { /* older browsers: kuji stays load-time fresh */ }
  }

  // ---- containers ----
  function bar() {
    var el = document.getElementById("neko-wr-bar");
    if (!el) {
      el = document.createElement("div");
      el.id = "neko-wr-bar";
      document.body.appendChild(el);
    }
    return el;
  }

  function setGated(on) {
    document.body.classList.toggle(GATED_CLASS, on);
    if (!on) {
      var b = document.getElementById("neko-wr-bar");
      if (b) b.remove();
      root.innerHTML = "";
    }
  }

  // ---- helpers ----
  function proxy(path, opts) {
    var url = proxyBase + path + (path.indexOf("?") >= 0 ? "&" : "?") + "variant=" + encodeURIComponent(variantId);
    var init = Object.assign({ headers: { "Content-Type": "application/json" }, credentials: "same-origin" }, opts || {});
    // Timeout so a hung request can't stall the poll loop (supported iOS 16.4+).
    if (typeof AbortSignal !== "undefined" && AbortSignal.timeout) init.signal = AbortSignal.timeout(8000);
    return fetch(url, init)
      .then(function (r) { if (!r.ok) throw new Error("proxy " + r.status); return r.json(); });
  }

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  // Full variant identity, e.g. 一番賞SANRIO玉桂狗 · 盤1 (variant part omitted
  // for single-variant products, whose title is Shopify's "Default Title").
  function variantLabel() {
    var full = productTitle;
    if (variantTitle && variantTitle !== "Default Title") {
      full += (full ? " · " : "") + variantTitle;
    }
    return full;
  }

  function paint(html) {
    root.innerHTML = '<div class="neko-wr neko-wr--card">' + html + "</div>";
    bar().innerHTML = '<div class="neko-wr neko-wr--bar">' + html + "</div>";
  }

  // Number-board band shared by every state: the variant identity line sits
  // INSIDE the band, above the headline row, so it's always clear which 盤
  // this queue belongs to (no extra bar outside the module).
  function band(rowHtml, turn) {
    var label = variantLabel();
    return (
      '<div class="neko-wr__band' + (turn ? " neko-wr__band--turn" : "") + '">' +
      (label ? '<div class="neko-wr__variant">' + escapeHtml(label) + "</div>" : "") +
      '<div class="neko-wr__bandrow">' + rowHtml + "</div>" +
      "</div>"
    );
  }

  function on(action, fn) {
    Array.prototype.forEach.call(
      document.querySelectorAll("[data-wr-action='" + action + "']"),
      function (el) { el.addEventListener("click", fn); }
    );
  }

  function turnUrl() {
    return productUrl + "?variant=" + encodeURIComponent(variantId) + "&view=turn";
  }

  function setButtonsBusy(label) {
    Array.prototype.forEach.call(
      document.querySelectorAll("#neko-waiting-room .neko-wr__btn, #neko-wr-bar .neko-wr__btn"),
      function (b) {
        b.disabled = true;
        if (label && b.tagName === "BUTTON") b.textContent = label;
      }
    );
  }

  // Black band with the live player count (idle / logged-out / opening).
  function countBand(state) {
    var n = state && typeof state.queueLength === "number" ? state.queueLength : 0;
    return band(
      ICON_PEOPLE +
      '<span class="neko-wr__bandlabel">排隊人數：</span>' +
      '<span class="neko-wr__num">' + n + "</span>"
    );
  }

  // ---- renderers ----
  function renderLogin(state) {
    paint(
      countBand(state) +
      '<div class="neko-wr__body">' +
      '<a class="neko-wr__btn" href="' + loginUrl + '">登入排隊</a>' +
      "</div>"
    );
  }

  function renderIdle(state) {
    if (state && state.blockedElsewhere) {
      if (state.heldOpening) {
        // Paid on ANOTHER variant with tickets still unrevealed: they must
        // NOT be able to drop that slot from here — status only, no button.
        paint(
          countBand(state) +
          '<div class="neko-wr__body">' +
          '<div class="neko-wr__warn">' +
          ICON_WARN +
          "<span>你仲有票未開 — 開晒啲票之後先可以喺呢度排隊</span>" +
          "</div>" +
          "</div>"
        );
        return;
      }
      // Queued on ANOTHER variant: keep this variant's live player count and
      // the normal action button — the copy makes the queue-switch explicit.
      paint(
        countBand(state) +
        '<div class="neko-wr__body">' +
        '<button type="button" class="neko-wr__btn" data-wr-action="switch">退出排緊嘅隊，排呢度</button>' +
        "</div>"
      );
      on("switch", function () {
        setButtonsBusy("轉緊隊…");
        var held = state.heldVariant;
        var leaveHeld = held
          ? fetch(proxyBase + "/leave?variant=" + encodeURIComponent(held), { method: "POST", credentials: "same-origin" })
          : Promise.resolve();
        leaveHeld
          .then(function () { return proxy("/join", { method: "POST" }); })
          .then(apply)
          .catch(fetchState);
      });
      return;
    }
    paint(
      countBand(state) +
      '<div class="neko-wr__body">' +
      '<button type="button" class="neko-wr__btn" data-wr-action="join">加入排隊</button>' +
      "</div>"
    );
    on("join", function () {
      setButtonsBusy("排緊隊…");
      proxy("/join", { method: "POST" }).then(apply).catch(fetchState);
    });
  }

  function renderQueued(state) {
    paint(
      band(
        '<div class="neko-wr__numgroup">' +
        '<div class="neko-wr__num">' + pad2(state.position) + "</div>" +
        '<div class="neko-wr__numlabel">你的位置</div>' +
        "</div>" +
        '<div class="neko-wr__slash">/</div>' +
        '<div class="neko-wr__numgroup">' +
        '<div class="neko-wr__num">' + pad2(state.queueLength) + "</div>" +
        '<div class="neko-wr__numlabel">總人數</div>' +
        "</div>"
      ) +
      '<div class="neko-wr__body">' +
      '<button type="button" class="neko-wr__btn" data-wr-action="leave">退出排隊</button>' +
      "</div>"
    );
    on("leave", function () {
      setButtonsBusy("退出中…");
      proxy("/leave", { method: "POST" }).then(apply).catch(fetchState);
    });
  }

  // Paid, revealing tickets (on THIS variant's page). Status only — release
  // is automatic (draw-completion detection or the bounded window); no
  // buttons, so the slot can't be dropped mid-opening.
  function renderOpening(state) {
    paint(
      countBand(state) +
      '<div class="neko-wr__body">' +
      '<div class="neko-wr__warn">' +
      ICON_WARN +
      "<span>開緊票中… 開晒你啲票，就會自動讓位比下一位</span>" +
      "</div>" +
      "</div>"
    );
  }

  // Instant placeholder painted at boot so the board frame is visible while
  // the first /state poll is in flight (~1s). Deliberately does NOT touch
  // currentState / lastSig: the 3-strike error guard, the leave-beacon rule
  // and the queue-movement signature baseline all key off those staying null.
  function renderSkeleton() {
    paint(
      band(
        ICON_PEOPLE +
        '<span class="neko-wr__bandlabel">排隊人數：</span>' +
        '<span class="neko-wr__num neko-wr__num--dim">--</span>'
      ) +
      '<div class="neko-wr__body">' +
      (loggedIn
        ? '<button type="button" class="neko-wr__btn" disabled>載入中…</button>'
        : '<a class="neko-wr__btn" href="' + loginUrl + '">登入排隊</a>') +
      "</div>"
    );
  }

  function renderActiveAndRedirect(state) {
    paint(
      band(
        ICON_CHECK +
        "<div>" +
        '<div class="neko-wr__turntitle">輪到你喇！</div>' +
        '<div class="neko-wr__turnsub">帶緊你去抽賞頁面…</div>' +
        "</div>",
        true
      ) +
      '<div class="neko-wr__body">' +
      '<a class="neko-wr__btn" href="' + turnUrl() + '">去抽賞' + ICON_ARROW + "</a>" +
      "</div>"
    );
    // Auto-redirect ONCE per turn window (sessionStorage guard survives
    // back-navigation so we don't bounce the customer in a loop).
    var guardKey = "nekoWrTurn:" + variantId + ":" + (state.turnExpiresAt || "");
    if (!sessionStorage.getItem(guardKey)) {
      sessionStorage.setItem(guardKey, "1");
      window.location.assign(turnUrl());
    }
  }

  // ---- state machine ----
  function apply(state) {
    currentState = state.state;

    // Queue movement detection: whenever position / total / state / head phase
    // changes, the kuji status most likely changed too → tell it to refetch.
    var sig = state.state + ":" + (state.position || "") + ":" + (state.queueLength || "") + ":" + (state.headPhase || "");
    if (lastSig !== null && sig !== lastSig) announceQueueChange();
    lastSig = sig;

    switch (state.state) {
      case "active": renderActiveAndRedirect(state); break;
      case "opening": renderOpening(state); break;
      case "queued":
        renderQueued(state);
        // Catch-all while waiting: draws land mid-turn (the previous buyer
        // opens tickets after paying), so refresh kuji every 4th poll (~16s)
        // even without queue movement. Poll loop is already visibility-gated.
        if (pollCount % 4 === 0) announceQueueChange();
        break;
      case "idle":
      default:
        if (!loggedIn) renderLogin(state);
        else renderIdle(state);
        break;
    }
  }

  var failCount = 0;

  function fetchState() {
    pollCount++;
    return proxy("/state", { method: "GET" })
      .then(function (state) {
        failCount = 0;
        apply(state);
      })
      .catch(function () {
        // FAIL SOFT + tolerant: single-poll failures are routine on mobile
        // (tab switches, page suspends, navigation aborting the request), so
        // keep showing the last good board and retry silently. Only paint the
        // error card after 3 consecutive failures with nothing better to show.
        failCount++;
        if (document.hidden) return; // suspend/switch — not a real failure
        if (failCount >= 3 && currentState === null) {
          paint('<p class="neko-wr__note">排隊系統暫時無法連接，請稍後重新整理。</p>');
        }
      });
  }

  function startPolling() {
    fetchState();
    pollTimer = setInterval(fetchState, POLL_MS);
    document.addEventListener("visibilitychange", function () {
      if (document.hidden) {
        if (pollTimer) { clearInterval(pollTimer); pollTimer = null; }
      } else if (!pollTimer) {
        fetchState();
        pollTimer = setInterval(fetchState, POLL_MS);
      }
    });
  }

  // NOTE (2026-07-12): the pagehide leave-beacon is GONE on purpose. Refreshing
  // the page and switching apps (however long) keep the queue spot — players
  // refresh to check the latest 配率, and some browsers fire pagehide on
  // app-switch, which silently dropped them. The ONLY ways out of the queue:
  // the explicit 退出排隊 button, or the turn countdown expiring unused.

  // ---- boot ----
  if (!gated) return; // ungated variant: inert (variantChange below re-checks)
  setGated(true);
  renderSkeleton(); // instant board frame; first poll response replaces it
  startPolling();

  // Re-evaluate when the variant changes. Rise declares its PubSub helpers as
  // top-level lexical globals (const/let), which do NOT attach to window — so
  // both `subscribe` and `PUB_SUB_EVENTS` must be referenced as BARE
  // identifiers behind typeof guards (same pattern as neko-kuji-status.js).
  // Using window.subscribe here silently never registers, leaving the module
  // stuck polling the first variant's queue after a 盤 switch.
  if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined" && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function (e) {
      var v = e && e.data && e.data.variant && e.data.variant.id;
      if (v && String(v) !== String(variantId)) {
        // Switching 盤 does NOT auto-leave the old queue — the blockedElsewhere
        // board on the new 盤 offers the explicit switch (退出排緊嘅隊，排呢度).
        variantId = String(v);
        if (e.data.variant.title) variantTitle = e.data.variant.title; // keep the identity strip current
        currentState = null;
        lastSig = null; // fresh signature baseline for the new variant
        fetchState();
      }
    });
  }
})();
